<template>
    <b-overlay :show="loading" rounded="sm">
        <div v-if="checkoffs.length > 0">
        <h4>
            {{
                selectedTemplate && selectedTemplate.name
                ? `${$translate('review_template')}: ${selectedTemplate && selectedTemplate.name
                }`
                : $translate('no_review_template')
            }}
        </h4>

    
        <b-table  ref="table"  :items="checkoffs" :class="'edit-div'" responsive :fields="fields" show-empty >
            <template #table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" :style="{
                    width:
                        field.key === 'sequence_no'
                            ? '150px'
                            : field.key !== 'id'
                                ? '350px'
                                : null,
                }" />
            </template>

            <template #cell(status)>
                <b-badge :variant="'warning'">Pending</b-badge>
            </template>
            <template #cell(checkoff_type)="row">
                <h6 v-b-tooltip.hover :title="row.item?.checkoff_type?.description" >{{row.item?.checkoff_type?.name}}</h6>
            </template>
            <template #cell(assigned_roles_for_notification)="row">
                <!-- <label for="input-notify_users" class="mb-3">
                    <strong>{{ $translate('roles_for_notification') }} </strong>
                </label> -->
                <multiselect id="input-checkoff_completion_notify_roles"  
                v-model="row.item.selectedRoles" 
                :options="row.item.roleOptions" 
                :searchable="true"
                :append-to-body="true"
                :multiple="true" 
                :preserve-search="true"
                :limit="2"
                :open-direction="'bottom'"
                @open="increaseTableHeight"
                @close="resetTableHeight"
                 ref="multiselect"
                label="fullName" track-by="id" :close-on-select="false">
                   
                </multiselect>
                <input type="hidden" v-model="row.item.checkoff_type_id" />
            </template>
           
        </b-table>
    </div>
    </b-overlay>
</template>
<script>
import ViewCheckoffSummary from './ViewCheckoffSummary.vue'
import ViewCheckoffForm from './ViewCheckoffForm.vue'
import ViewCheckoffAttachments from './ViewCheckoffAttachments.vue'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import Multiselect from 'vue-multiselect'
export default {
    name: 'orders-Checkoff-add',
    components: {
        ViewCheckoffSummary,
        ViewCheckoffForm,
        ViewCheckoffAttachments,
        Multiselect
    },
    mixins: [popupMixins, permissionsMixins],
    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
    },
    data: () => ({
        processModal: false,
        model: {
            comments: null,
            // completed_at
            officer_name: null,
            checkoff_type_id: null,
            signature_data: null,
        },
        selectedItem: null,
        loading: false,
        tabIdx: 0,
        roleOptions: [],
        default_select : [],
        checkoffs: [],
        processedItems: new Map(),
    }),
    filters: {
        actionVariant(status) {
            switch (status) {
                case 'pending':
                    return 'warning'
                case 'processing':
                    return 'info'
                case 'completed':
                    return 'success'
            }
        },
        displayTime(time) {
            var retutnTime = 'N/A'
            if (time != '') {
                const utc = time.split(' ').join('T').split('.')[0] + '.000Z'
                retutnTime = new Date(utc).toLocaleString()
            }
            return retutnTime
        },
    },
    computed: {
        fields() {
            return [
                {
                    key: 'sequence_no',
                    label: this.$translate('no.'),
                },
                {
                    key: 'checkoff_type',
                    label: this.$translate('workflow_step'),
                    formatter: value => value.name,
                },
                { key: 'status', label: this.$translate('status'),formatter: 'pending' },
                // { key: 'comments', label: this.$translate('comments'), formatter: value => value ? value : 'N/A' },
                // { key: 'completed_at', label: this.$translate('completed_on') },
                // {
                //     key: 'user',
                //     label: this.$translate('signature_by'),
                //     formatter: x =>
                //         ((x || {}).first_name || '') +
                //         ' ' +
                //         ((x || {}).last_name || ''),
                // },
                {
                    key: 'assigned_roles_for_notification',
                    label: this.$translate('assigned_user_for_notification'),
                    thClass:'order-table-description',
                    tdClass:'order-table-description',
                },
                // { key: 'action', label: this.$translate('actions') },
            ]
        },
        checkoffTabs() {
            return {
                summary: 0,
                images: 1,
            }
        },
        user() {
            return this.$store.state.user
        },
        order() {
            const item = this.$store.state.orders.item
            console.log('computed---order', item)
            return item || {}
        },
        // checkoffs() {
        //     const item = this.$store.state.checkoffTypes.work_flows || []
        //     console.log('computed---checkoffs', item)
        //     return item || {}
        // },
        checkoffItems() {

            if(this.checkoffs != null){

           
            let items = this.checkoffs || []
            //add status
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                const status = item.completed
                    ? 'completed'
                    : item.user_id || item.checkoff_attachments.length
                        ? 'processing'
                        : 'pending'
                this.$set(item, 'status', status)
                this.$set(item, 'roles', item.checkoff_type?.checkoff_type_roles?.map(x=>x.role?.name).join(', '))
                this.$set(items, i, item)
            }

            //sort
            items.sort((a, b) => a.sequence_no - b.sequence_no)

            //determine active state
            let firstAvailableItem = null
            for (let i = 0; i < items.length; i++) {
                const item = items[i]

                this.$set(item, 'active', false)
                if (!firstAvailableItem && item.status != 'completed') {
                    firstAvailableItem = item
                    this.$set(item, 'active', true)
                }

                if (
                    firstAvailableItem &&
                    item.status != 'completed' &&
                    firstAvailableItem.sequence_no == item.sequence_no
                ) {
                    this.$set(item, 'active', true)
                }

                if (item.status != 'completed') {
                    const user_role = this.user.roles[0].role_id
                    console.log('user role', user_role)
                    const type_roles = item.checkoff_type.checkoff_type_roles
                    console.log('type roles', type_roles)
                    const userHasRole = type_roles.some(
                        x => x.role_id === user_role
                    ) /*  ||  type_roles.length === 0  */
                    console.log('userHasRole', userHasRole)
                    if (item.active) this.$set(item, 'active', userHasRole)
                }
                console.log('item.active', item.active)
                this.$set(items, i, item)
            }

            console.log('Check Off Items - ', items)
            return items
           }
        },
        selectedTemplate() {
           return this.checkoffs.length > 0 ? this.checkoffs[0].template : null;
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    watch: {
        checkoffs: {
            handler(newCheckoffs) {
                newCheckoffs.forEach(rowItem => {
                    // Watch each row's selectedRoles
                    this.$watch(
                        () => rowItem.selectedRoles,
                        this.emitUpdatedCheckoffs, // Emit the entire updated checkoffs array
                        { deep: true }
                    );
                });
            },
            deep: true, // Ensure the watcher tracks changes within the array and its objects
            immediate: true, // Run this watcher immediately on component mount
        },
    },
    async mounted() {
        this.loading = true;
        await this.loadCheckoffs();
        // this.default_select = this.$store.state.checkoffTypes.work_flows;
        // console.log('this is check--------',this.default_select);
        // if (this.default_select && this.default_select.checkoff_type) {
        //     const roleIds = this.default_select.checkoff_type.checkoff_type_roles.map(role => role.role_id);
        //     console.log('role users-----',roleIds);       
        //     let users = await  this.$store.dispatch('users/fetchUserRole',roleIds);
        //     console.log('role users-----',users);           
        // }
        // this.roleOptions = this.$store.state.checkoffTypes.work_flows.notify_this_user;
        // console.log('checkoff user', this.user)
        // console.log('checkoff order', this.order)
         this.loading = false;
    },
    methods: {
        disabledReview(item) {
            return !item.active && item.status != 'completed'
        },
        checkRoles(item) {
            const userRole = this.user.roles[0].role.name
            const checkReviewRoles =
                item && item.checkoff_type.checkoff_type_roles.some(x =>
                    x.role.name.includes(userRole)
                ) || null
            return !!checkReviewRoles
        },
        activityReleaseCheck(item) {
            return item.checkoff_type && item.checkoff_type.do_release == 1 && (this.order.released == 0 && this.order.completed == 0)
        },
        actionLabel(status) {
            switch (status) {
                case 'pending':
                case 'processing':
                    return this.$translate('process')
                case 'completed':
                    return this.$translate('view')
            }
        },
        openProcessModal(item) {
            this.selectedItem = item
            console.log('item', item)
            this.model.checkoff_type_id = item.checkoff_type_id
            this.model.comments = item.comments
            this.model.completed = item.completed
            console.log('model before', this.model)
            this.processModal = true
        },

        getPosition(options) {
            return new Promise((resolve, reject) =>
                navigator.geolocation.getCurrentPosition(
                    resolve,
                    reject,
                    options
                )
            )
        },

        updateStatus() {
            if (!this.selectedItem.user_id) {
                this.submitCheckoff(true)
            }
        },
        updateDropdownSize() {
            const ms = this.$refs.multiselect;
            ms.$refs.list.style.width = `${this.$el.clientWidth}px`;
            ms.$refs.list.style.position = 'fixed';
        },
        async submitCheckoff() {
            
            this.$refs.checkoffs.saveSignature()
            try {
                const hasSignatureData = this.model.signature_data
                if (hasSignatureData !== null) {
                    console.log("gettt")
                    const title = this.$translate('review_completed')
                    const message = `${this.$translate('review_automaticly_completed')}?`
                    const result = await this.confirmMessage(title, message)
                    if (result) {
                        this.model.completed = 1
                        this.loading = true
                        const {
                            order: { id },
                            model: { comments, checkoff_type_id, completed, signature_data },
                        } = this

                        if (!navigator.geolocation) {
                            throw new Error(this.$translate('cannot_identify_location'))
                        }
                        const position = await this.getPosition()

                        let lat = position.coords.latitude
                        let long = position.coords.longitude
                        const data = {
                            checkoff_type_id,
                            comments,
                            officer_name: this.user.first_name + ' ' + this.user.last_name,
                            signature_data,
                            lat,
                            long,
                            completed,
                        }

                        const path = 'orders/updateCheckoff'
                        const order_checkoff_id = this.selectedItem.id

                        await this.$store.dispatch(path, {
                            id,
                            order_checkoff_id,
                            data,
                        })
                        
                        this.processModal = false
                        this.$nextTick(()=>{
                            this.genericToast(
                            this.$translate('activity_review'),
                            this.$translate('updated'),
                            'success',
                            `${this.$translate('activity_review')} ${this.$translate(
                                'update_alert'
                            )}`
                        )
                        })
                    }
                } else {
                    this.loading = true
                    const {
                        order: { id },
                        model: { comments, checkoff_type_id, completed, signature_data },
                    } = this
                    if (!navigator.geolocation) {
                        throw new Error(this.$translate('cannot_identify_location'))
                    }
                    const position = await this.getPosition()
                    let lat = position.coords.latitude
                    let long = position.coords.longitude
                    const data = {
                        checkoff_type_id,
                        comments,
                        officer_name: this.user.first_name + ' ' + this.user.last_name,
                        signature_data,
                        lat,
                        long,
                        completed,
                    }
                    const path = 'orders/updateCheckoff'
                    const order_checkoff_id = this.selectedItem.id
                    await this.$store.dispatch(path, {
                        id,
                        order_checkoff_id,
                        data,
                    })
                    this.processModal = false
                    this.$nextTick(()=>{
                        this.genericToast(
                        this.$translate('activity_review'),
                        this.$translate('updated'),
                        'success',
                        `${this.$translate('activity_review')} ${this.$translate(
                            'update_alert'
                        )}`
                    )
                    })
                    
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    const errorMessage = error.response.data.error.message;
                   
                    this.doToast(this.$translate('error'), errorMessage, 'danger');
                } else {
                    console.log('this is error!--------', error);
                    this.doToast(this.$translate('error'), error.message, 'danger');
                }
                // this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                
                this.loading = false
            }
        },

        selectedRoles() {
            this.roleOptions.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            var selected = this.roleOptions.filter(s => this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
            var notSelected = this.roleOptions.filter(s => !this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
            this.roleOptions = [...selected, ...notSelected];
        },

        async loadCheckoffs() {
            console.log('loadCheckoffs called'); // Debugging to check method calls
            
            // Clear previous checkoffs to prevent duplicate options
            this.checkoffs = [];
            this.processedItems.clear(); // Reset tracking of processed items

            const workFlows = this.$store.state.checkoffTypes.work_flows || [];

            // Process each workflow item
            for (const item of workFlows) {
                const checkoffId = item.id;

                // Skip processing if the item is already processed
                if (this.processedItems.has(checkoffId)) {
                continue;
                }


                const roleIds = item.checkoff_type.checkoff_type_roles.map(
                (role) => role.role_id
                );
                 console.log('role_ids--------',roleIds);
                // Fetch users for the current role IDs
                let users = [];
                if (roleIds.length > 0) {
                    const response =  await this.$store.dispatch("users/fetchUserRole", roleIds);
                    console.log('repsonse--',response.data.success.data);
                      // Extract users from the response
                    if (response && response.data.success.data) {
                        users = response.data.success.data.map(user => ({
                        ...user,
                        fullName: `${user.first_name} ${user.last_name} (${user.name})`
                      }));
                    } else {
                        console.error('Unexpected response format:', response);
                    }
                
                }

                let selectedUsers = [];
               
                if (item.notify_this_user && Object.keys(item.notify_this_user).length > 0) {
                    const notifyUserIds = Object.values(item.notify_this_user).map(user => user.id); // Extract user IDs
                    selectedUsers = users.filter(user => notifyUserIds.includes(user.id));
                }
               
                // Add role options and a selectedRoles array to the item
                this.checkoffs.push({
                ...item,
                roleOptions: users,
                selectedRoles: selectedUsers, // This will store selected roles for the current checkoff
                });

                // Mark item as processed
                this.processedItems.set(checkoffId, true);
                this.$emit('updateCheckoffData', this.checkoffs);
            }

            console.log('Checkoffs:', this.checkoffs); // Debugging to inspect the final checkoffs array
            },
            emitUpdatedCheckoffs() {
            // Emit the entire checkoffs array with all updated values
            this.$emit('updateCheckoffData', this.checkoffs);
        },

        increaseTableHeight() {
      this.$nextTick(() => {
        const table = this.$refs.table.$el;
        const multiselect = this.$refs.multiselect.$el;
        const dropdownHeight = multiselect.querySelector('.multiselect__content').offsetHeight;
        console.log('table.scrollHeight',table.scrollHeight);
        console.log('dropdownHeight',dropdownHeight);
        // Increase table height to accommodate dropdown
        table.style.height = `${table.scrollHeight + 0}px`;
      });
    },
    resetTableHeight() {
      this.$nextTick(() => {
        const table = this.$refs.table.$el;
        table.style.height = ''; // Reset to default height
      });
    }
       
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.edit-div{
    overflow-y: visible !important;
}
</style>